import { render } from "./MessagesConversationItem.vue?vue&type=template&id=56c1bedb&scoped=true&ts=true"
import script from "./MessagesConversationItem.vue?vue&type=script&lang=ts"
export * from "./MessagesConversationItem.vue?vue&type=script&lang=ts"

import "./MessagesConversationItem.vue?vue&type=style&index=0&id=56c1bedb&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c1bedb"]])

export default __exports__